export default __webpack_public_path__ + "static/media/284.a3661c11.jpg";